import React, { useState, useEffect, useCallback, useRef } from "react";
import "./index.css";
import saveBtn from "../../../../assets/design-revamp-product/product-icons/save-btn-product.svg";
import { createProduct } from "../../../../apis/Product";
import { useNavigate } from "react-router-dom";
import ProductBar from "../ProductBar";
import VariationSystem from "../VariationSystems";
import ProductSubgroupDropdown from "../ProductSubgroupDropdown";
import EditableProductComponent from "../ProductComponentBox/EditableProductComponent";

const ProductModal = ({ onClose, year, subgroupId, business, subgroups }) => {
  const [idBusiness, setIdBusiness] = useState("");
  const [status, setStatus] = useState(false);
  const [name, setName] = useState("");
  const [productNum, setProductNum] = useState("");
  const [variationCategories, setVariationCategories] = useState([]);
  const navigate = useNavigate();
  const [chosenSubgroup, setChosenSubgroup] = useState();
  const modalRef = useRef(null);

  const handleVariationsChange = useCallback((newVariations) => {
    setVariationCategories(newVariations);
  }, []);

  const handleSubgroupChange = useCallback((chosenSubgroup) => {
    setChosenSubgroup(chosenSubgroup);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Handle ESC key
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [onClose]);

  const handleMove = useCallback(
    () =>
      navigate(
        `/product/${idBusiness}?business=${chosenSubgroup?.business}&year=${year}`,
        {
          replace: true,
        }
      ),
    [navigate, idBusiness, chosenSubgroup, year]
  );

  useEffect(() => {
    if (status === true) handleMove();
  }, [status, handleMove]);

  const handleSave = () => {
    createProduct({
      name: name,
      productNum: productNum,
      variationCategories: variationCategories,
      year: year,
      setStatus: setStatus,
      setIdBusiness: setIdBusiness,
      subgroupId: chosenSubgroup.id,
      business: chosenSubgroup.business,
    });
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };
  return (
    <>
      <div className="modal-overlay"></div>
      <div
        className="modal-content-base"
        onClick={handleModalClick}
        ref={modalRef}
      >
        <ProductBar
          variationItems={variationCategories}
          subgroup={chosenSubgroup?.name}
        />
        <div style={{ display: "flex", marginTop: "12px" }}>
          <EditableProductComponent
            name={name}
            setName={setName}
            productNum={productNum}
            setProductNum={setProductNum}
            variationValues={variationCategories}
            subgroup={chosenSubgroup?.name}
          />
          <ProductSubgroupDropdown
            subgroups={subgroups}
            onClick={handleSubgroupChange}
          />
          <VariationSystem
            onVariationsChange={handleVariationsChange}
            chosenSubgroup={chosenSubgroup ? chosenSubgroup : {}}
          />
        </div>

        <img
          src={saveBtn}
          alt="Add Product Button"
          width={25}
          height={25}
          className="modal-save-btn"
          onClick={handleSave}
        />
      </div>
    </>
  );
};

export default ProductModal;
